export default (length: number, index: number, defaultUserString: string, userWithComma: string, userWithAnd: string) => {
  if (length === 2 && index === 1) {
    return userWithAnd
  } else if (length > 2) {
    if (index === length - 1) {
      return userWithAnd
    } else if (index !== length - 2) {
      return userWithComma
    }
  }
  return defaultUserString
}
